export default __webpack_public_path__ + "static/media/tented.f44fcf5e.png";